import { type DataLevelItem, type LevelItem } from './level-item.interface';

/**
 * Convert element from 'DataLevelItem' type to 'LevelItem' type.
 * The conversion add information such unique id and checkbox attributes.
 */
export function convertDataLevelItemsToLevelItems(
  dataLevelItems: readonly DataLevelItem[],
): LevelItem[] {
  let id = 0;
  // eslint-disable-next-line func-style
  const convertToLevelItems: (d: DataLevelItem) => LevelItem = data => ({
    ...data,
    id: id++,
    indeterminate: false,
    children:
      data.children && data.children.map(child => convertToLevelItems(child)),
  });

  return (
    dataLevelItems && dataLevelItems.map(child => convertToLevelItems(child))
  );
}

/**
 * Convert LevelItems to DataLevelItems by removing items used only by component
 */
export function convertLevelItemsToDataLevelItems(
  levelItems: readonly LevelItem[],
): DataLevelItem[] {
  // eslint-disable-next-line func-style
  const convertToDataItems: (li: LevelItem) => DataLevelItem = li => {
    const { data, template, isLeaf, selected, children } = li;

    return {
      data,
      template,
      isLeaf,
      selected,
      children: children && children.map(child => convertToDataItems(child)),
    };
  };

  return levelItems && levelItems.map(child => convertToDataItems(child));
}

/**
 * Default trackBy function to use in ngFor. Return the id of the row.
 */
export function trackByDefault(_: number, item: LevelItem): number {
  return item.id;
}
